import React from 'react'
import { PropTypes } from 'prop-types'
import classNames from 'classnames'

import { useTranslation } from '../../../../utils/providers'

const PasswordStrength = ({ className, value }) => {
  const { t } = useTranslation()
  const password = value
  if (!password) {
    return null
  }

  const specialAll = /^(?=.{8,})(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*\W).*$/
  let strengthText = t('FORM_LABEL_PW_WEAK')
  let strength = 'weak'

  if (password.length > 6) {
    if (password.match(specialAll)) {
      if (password.length > 10) {
        strengthText = t('FORM_LABEL_PW_VERY_STRONG')
        strength = 'very-strong'
      } else {
        strengthText = t('FORM_LABEL_PW_STRONG')
        strength = 'strong'
      }
    } else {
      strengthText = t('FORM_LABEL_PW_MEDIUM')
      strength = 'medium'
    }
  }

  const containerClass = classNames(
    'password-strength-container mb-3',
    className
  )
  const strengthClass = classNames('strength-indicator', strength)

  return (
    <div className={containerClass}>
      <div className="password-strength-text">{strengthText}</div>
      <div className="password-indicator">
        <div className={strengthClass}></div>
      </div>
    </div>
  )
}

PasswordStrength.propTypes = {
  className: PropTypes.string,
  value: PropTypes.string,
}

export default PasswordStrength
